import React from 'react'
import { ContentVerified } from './components/content-verified'
import { useSelector } from 'react-redux'

const DashboardProfile = () => {
  const account = useSelector(state => state.account.data)

  return <ContentVerified account={account} />
}

export { DashboardProfile }
